import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";
import { AffidavitCertificateUpdateListResponse } from "src/models/AffidavitCertificateUpdate.model";

export interface GeneratedCertificateSliceStateType {
  items: AffidavitCertificateUpdateListResponse[] | [];
  totalItems: number;
  isTableLoading: boolean;
  page: number;
  rowsPerPage: number;
  searchValue: string;
  sortValue: { field: string; value: "DESC" | "ASC" };
  filterBy: {
    fieldName: string;
    value: string[];
  }[];
  dateFilter: {
    start_date: string | null | any;
    end_date: string | null | any;
  };
  generatedDateFilter: {
    start_date: string | null | any;
    end_date: string | null | any;
  };
  orderByValue: number;
  startSerialNumber: number;
}

const initialState: GeneratedCertificateSliceStateType = {
  items: [],
  totalItems: 0,
  isTableLoading: false,
  page: 1,
  rowsPerPage: 10,
  searchValue: "",
  sortValue: { field: "createdAt", value: "DESC" },
  filterBy: [],
  dateFilter: {
    start_date: "",
    end_date: "",
  },
  generatedDateFilter: {
    start_date: moment()?.subtract(1, "days"),
    end_date: new Date(),
  },
  orderByValue: -1,
  startSerialNumber: 1,
};

const GeneratedCertificateSlice: any = createSlice({
  name: "generatedCertificate",
  initialState,
  reducers: {
    resetState: (state) => {
      return initialState;
    },
    setItems: (
      state,
      action: PayloadAction<AffidavitCertificateUpdateListResponse[] | []>
    ) => {
      state.items = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
      document.getElementById("scroll-top")?.scrollTo(0, 0);
    },
    setRowsPerPage: (state, action: PayloadAction<number>) => {
      state.rowsPerPage = action.payload;
      state.page = 1;
      document.getElementById("scroll-top")?.scrollTo(0, 0);
    },
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.searchValue = action.payload;
      state.page = 1;
    },
    setSortValue: (
      state,
      action: PayloadAction<{ field: string; value: "DESC" | "ASC" }>
    ) => {
      state.sortValue = action.payload;
      state.page = 1;
    },
    setTotalItems: (state, action: PayloadAction<number>) => {
      state.totalItems = action.payload;
    },
    setIsTableLoading: (state, action: PayloadAction<boolean>) => {
      state.isTableLoading = action.payload;
    },
    setFilterBy: (
      state,
      action: PayloadAction<{ fieldName: string; value: string[] }[]>
    ) => {
      state.filterBy = action.payload;
      state.page = 1;
    },
    setDateFilter: (
      state,
      action: PayloadAction<{ start_date: string; end_date: string }>
    ) => {
      state.dateFilter = action.payload;
    },
    setGeneratedDateFilter: (
      state,
      action: PayloadAction<{ start_date: string; end_date: string }>
    ) => {
      state.generatedDateFilter = action.payload;
    },
    setOrderByValue: (state, action: PayloadAction<number>) => {
      state.orderByValue = action.payload;
    },
    setStartSerialNumber: (state, action: PayloadAction<number>) => {
      state.startSerialNumber = action.payload;
    },
  },
});

export const {
  setItems,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setSortValue,
  setTotalItems,
  setIsTableLoading,
  setFilterBy,
  setDateFilter,
  setGeneratedDateFilter,
  resetState,
  setOrderByValue,
  setStartSerialNumber,
} = GeneratedCertificateSlice.actions;
export default GeneratedCertificateSlice.reducer;
